export default __webpack_public_path__ + "5ce092d.png";